import { createSlice } from "@reduxjs/toolkit";

const purchaseImportTableDataSlice = createSlice({
  name: "purchaseImportTableData",
  initialState: [],
  reducers: {
    addItemToTableData: (state, action) => {
      const item = { ...action.payload };
      if (item._replaceIndex !== undefined && item._replaceIndex !== null) {
        const replaceIndex = item._replaceIndex;
        delete item._replaceIndex;
        state[replaceIndex] = item;
      } else {
        state.push(item);
      }
    },

    replaceItemInTableData: (state, action) => {
      const { index, item } = action.payload;
      state[index] = item;
    },
    updateTableRowValue: (state, action) => {
      const {
        index,
        free,
        discAmt,
        qty,
        Cost,
        Tax1,
        Rate1,
        Rate2,
        exp_date,
        batch,
        TaxEnabled,
        exchangeRate,
        UnitRateFC,
        perc,
      } = action.payload;
      state[index].free = free;
      state[index].discAmt = discAmt;
      state[index].qty = qty;
      state[index].Cost = Cost;
      state[index].Rate1 = Rate1;
      state[index].Rate2 = Rate2;
      state[index].exp_date = exp_date;
      state[index].batch = batch;
      state[index].total = qty * Cost - discAmt;
      state[index].UnitRateFC =
        UnitRateFC !== undefined
          ? UnitRateFC
          : (Cost / exchangeRate).truncateDecimal(2);
      state[index].TotalFc = (
        (qty * Cost - discAmt) /
        exchangeRate
      ).truncateDecimal(2);
      state[index].taxAmt =
        TaxEnabled.Nam !== "YES"
          ? ((qty * Cost - discAmt) * Tax1) / 100
          : (qty * Tax1 * Cost) / (100 + Tax1);
      // state[index].netValue =
      //   TaxEnabled.Nam !== "YES"
      //     ? qty * Cost - discAmt + ((qty * Cost - discAmt) * Tax1) / 100
      //     : qty * Cost;
      state[index].netValue = qty * Cost - discAmt;
      state[index].unit_price =
        TaxEnabled?.Nam !== "YES"
          ? parseFloat(Cost) || 0
          : (parseFloat(Cost) || 0) / (1 + (parseFloat(Tax1) || 0) / 100);

      if (perc !== undefined) {
        state[index].perc = perc;
      } else if (Cost === 0 || Rate1 === 0) {
        state[index].perc = (0).truncateDecimal(2);
      } else {
        state[index].perc = (((Rate1 - Cost) / Cost) * 100).truncateDecimal(2);
      }
    },

    deleteItemByIndex: (state, action) => {
      state.splice(action.payload, 1);
    },

    deleteItemFromTableData: (state, action) => {
      const index = state.findIndex(
        (item) => item.ItemNo === action.payload.ItemNo,
      );
      if (index !== -1) {
        state.splice(index, 1);
      }
    },
    clearTableData: (state, action) => {
      return [];
    },
    // New reducer to replace the array with new data
    replaceTableData: (state, action) => {
      return action.payload; // Set the state to the new data
    },
  },
});

export const {
  addItemToTableData,
  deleteItemByIndex,
  deleteItemFromTableData,
  clearTableData,
  replaceTableData,
  updateTableRowValue,
  replaceItemInTableData,
} = purchaseImportTableDataSlice.actions;
export default purchaseImportTableDataSlice.reducer;
